import React, { useState } from 'react';

import { cutText } from 'utils';

import ProgressBar from 'pages/Teachers/StudentListV2/components/ProgressBar';

import styles from './styles.module.scss';

const StudentRow = ({ student }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleRow = () => setIsExpanded(!isExpanded);

  return (
    <>
      <tr className={styles.mainRow}>
        <td>{cutText({ text: student.name, char: 30 })}</td>
        <td>
          {student.is_expandable ? (
            <button className={styles.expandButton} onClick={toggleRow}>
              {cutText({ text: student.section_label, char: 30 })}
              <span
                className={isExpanded ? styles.chevronUp : styles.chevronDown}
              >
                ▼
              </span>
            </button>
          ) : (
            <span className={styles.sectionText}>
              {cutText({ text: student.section_label, char: 30 })}
            </span>
          )}
        </td>
        <td className={styles.lightText}>{student.recent_upload}</td>
        <td>
          <ProgressBar
            student={student}
            currentPoints={student.current_points}
            maxPoints={student.max_points}
          />
        </td>
      </tr>

      {student.is_expandable &&
        isExpanded &&
        student.assignments?.map((assignment) => (
          <tr key={assignment.id} className={styles.subRow}>
            <td></td>
            <td className={styles.lightText}>{assignment.name}</td>
            <td className={styles.lightText}>{student.recent_upload}</td>
            <td>
              <ProgressBar
                student={student}
                currentPoints={assignment.current_points}
                maxPoints={assignment.max_points}
                isSubRow={true}
              />
            </td>
          </tr>
        ))}
    </>
  );
};

export default StudentRow;
